import { Type } from '@angular/core';
import { AutomationTrigger } from '@kinet-open-network/shared/data-access/model';
import { TriggerComponent } from './abstract-trigger.component';
import { CronTriggerComponent } from './cron-trigger.component';
import { FieldChangeTriggerComponent } from './field-change-trigger.component';

export const TRIGGERS_MAP: Partial<
  Record<AutomationTrigger, Type<TriggerComponent<AutomationTrigger>>>
> = {
  [AutomationTrigger.Cron]: CronTriggerComponent,
  [AutomationTrigger.FieldChange]: FieldChangeTriggerComponent,
};
